var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationRatingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#F93749",
    fillOpacity: 0.16,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5245 25.4635C31.6741 25.0029 32.3259 25.0029 32.4755 25.4635L33.6839 29.1824C33.7508 29.3884 33.9428 29.5279 34.1594 29.5279H38.0696C38.554 29.5279 38.7554 30.1477 38.3635 30.4324L35.2001 32.7307C35.0248 32.8581 34.9515 33.0838 35.0184 33.2898L36.2268 37.0086C36.3764 37.4693 35.8492 37.8523 35.4573 37.5676L32.2939 35.2693C32.1186 35.1419 31.8814 35.1419 31.7061 35.2693L28.5427 37.5676C28.1508 37.8523 27.6236 37.4693 27.7732 37.0086L28.9816 33.2898C29.0485 33.0838 28.9752 32.8581 28.7999 32.7307L25.6365 30.4324C25.2446 30.1477 25.446 29.5279 25.9304 29.5279H29.8406C30.0572 29.5279 30.2492 29.3884 30.3161 29.1824L31.5245 25.4635Z",
    fill: "#F93749"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRatingIcon);
export default __webpack_public_path__ + "static/media/notification-rating-icon.459aa1009fb3e1f8c54bbb5e015eade7.svg";
export { ForwardRef as ReactComponent };